import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Input,
    Row,
} from "reactstrap";

import EcommerceOrdersModal from "components/Common/EcommerceOrdersModal";
import ExpandableQuestionTable from "components/Common/CommonExpandableQuestionTable";
import QuestionTypeAddEditModal from "pages/AllCommonModal/QuestionTypeAddEditModal/question-type-add-edit-modal";
import { submitQuestionTypeFilterData } from "model/QuestionTypeModel";
import Spinners from "components/Common/Spinner";
import { pascalToCamel } from "helpers/GeneralHelper";
import { useQuestionTypeContext } from "libs/context/QuestionTypeContext";
import Loaders from "components/Common/Loaders";
import { usePermissionContext } from "libs/context/PermissionContext";

const QuestionType = () => {
    const { permissionData } = usePermissionContext() || {};
    const { fetchQuestionTypeContextData, questionTypeContextData } = useQuestionTypeContext() || {};
    const [questionTypeAddEditModalOpen, setQuestionTypeAddEditModalOpen] = useState(false);
    const [modal1, setModal1] = useState(false);
    const toggleViewModal = () => setModal1(!modal1);

    // User input in the search box
    const [searchTerm, setSearchTerm] = useState("");

    // Actual term to search when button is clicked
    const [searchQuery, setSearchQuery] = useState("");
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const [itemId, setItemId] = useState(null); // ✅ important
    const [questionTypeData, setQuestionTypeData] = useState(null); // ✅ important
    const [loading, setLoading] = useState(false);
    const [tableMetaData, setTableMetadata] = useState();
    const [questionDetails, setQuestionDetails] = useState();

    const initialState = {
        name: "",
        status: true
    };

    const [formData, setFormData] = useState(initialState);

    const questionTypeActionPermissions = useMemo(
        () => ({
            canCreate: Boolean(permissionData?.QuestionTypeAddAccess),
            canEdit: Boolean(permissionData?.QuestionTypeUpdateAccess),
        }),
        [permissionData]
    );

    const hasAnyQuestionTypeRowAction = useMemo(
        () => questionTypeActionPermissions.canEdit,
        [questionTypeActionPermissions]
    );

    const handleEdit = (row) => {
        // console.log('rowwwww', row)
        setQuestionDetails(row)
        setItemId(row?.id);
        setQuestionTypeAddEditModalOpen(true);
    };

    useEffect(() => {
        fetchQuestionTypeContextData()
        fetchQuestionTypeList();
    }, []);

    const fetchQuestionTypeList = async () => {
        setLoading(true);
        let response = await submitQuestionTypeFilterData({});
        let questionTypeData = response?.data;
        if (response) {
            setQuestionTypeData(questionTypeData);
            setLoading(false);
        } else {
            setQuestionTypeData([]);
            setLoading(false);
        }
    };

    // 🔍 Filter only when search button clicked (uses searchQuery)
    const filteredData = useMemo(() => {
        if (!searchQuery.trim()) return questionTypeData;

        return questionTypeData.filter((item) =>
            Object.values(item).some((val) =>
                String(val).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [questionTypeData]);

    const handleSearchSubmit = async (value) => {
        setLoading(true);

        const payload = {
            search: value, // adjust key if backend expects something else
        };

        let response = await submitQuestionTypeFilterData(payload);
        let searchData = response?.data;

        if (response) {
            setQuestionTypeData(searchData);
        } else {
            setQuestionTypeData([]);
        }

        setLoading(false);
    };

    useEffect(() => {
        const valueReModified = questionTypeContextData?.table?.columns?.map(col => ({
            Header: col?.title,
            accessor: pascalToCamel(col?.field),
        }));
        // console.log('valueReModified', valueReModified)
        setTableMetadata(valueReModified)
    }, [questionTypeContextData]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* View Modal */}
                    <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
                    {/* 📋 Table Section */}
                    <Card>
                        <CardBody>

                            <div className="d-flex justify-content-between align-items-center">
                                <h5 className="fw-bold mb-3">Question Type</h5>



                                {questionTypeActionPermissions.canCreate ? (
                                    <Col xs="12" md="4" className="text-md-end mt-2 mt-md-0">
                                        <Button
                                            color="primary"
                                            onClick={() => {
                                                setQuestionTypeAddEditModalOpen(true);
                                                setItemId(null);
                                                setFormData(initialState)
                                            }}
                                        >
                                            + Create
                                        </Button>
                                    </Col>
                                ) : null}
                            </div>
                            <hr />

                            <Row className="align-items-center g-2 mb-4">
                                <Col xs="12" md="8">
                                    <div className="d-flex border rounded w-100 category-search-input">
                                        <Input
                                            type="text"
                                            placeholder="Search by name"
                                            className="border-0"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e?.target?.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSearchSubmit(searchQuery?.trim());
                                                }
                                            }}
                                        />

                                        <Button
                                            className="search-icon-button"
                                            onClick={() => handleSearchSubmit(searchQuery?.trim())}
                                        >
                                            <i className="fa fa-search"></i>
                                        </Button>
                                    </div>
                                </Col>
                            </Row>

                            {(!loading && questionTypeData?.length && tableMetaData?.length) ? (
                                <ExpandableQuestionTable columns={tableMetaData} data={filteredData}
                                    isEditAccess={questionTypeActionPermissions.canEdit}
                                    onEdit={
                                        questionTypeActionPermissions.canEdit ? handleEdit : undefined
                                    }
                                    isPagination={false}
                                    isActionRequired={hasAnyQuestionTypeRowAction}
                                    isCheckboxLeftSide={false} fetchQuestionTypeList={fetchQuestionTypeList}
                                    pageName="Question Type"
                                />
                            ) : 
                            // <Spinners setLoading={setLoading} />
                            <Loaders />
                            }
                            {/* {
                            <ExpandableQuestionTable columns={columns} data={filteredData} isEditAccess={true}
                                onEdit={handleEdit} />
                            } */}
                        </CardBody>
                    </Card>
                    {/* 🧩 Add/Edit Modal */}
                    <QuestionTypeAddEditModal
                        setQuestionTypeAddEditModalOpen={setQuestionTypeAddEditModalOpen}
                        questionTypeAddEditModalOpen={questionTypeAddEditModalOpen}
                        setFormData={setFormData}
                        formData={formData}
                        itemId={itemId}
                        setItemId={setItemId}
                        getQuestionTypeList={fetchQuestionTypeList}
                        setJobRequiredData
                        questionTypeDetails={questionDetails}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

QuestionType.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(QuestionType);
